import App from "../App";

export default [
  {
    path: "",
    component: App,
    children: [
      {
        path: "/",
        component: r =>
          require.ensure(
            [],
            () => r(require("../page/homeIndex/homeIndex")),
            "homeIndex"
          ),
        redirect: "/approve",
        children: [
          // {
          //   // 欢迎页
          //   path: "/",
          //
          //   component: r =>
          //     require.ensure([], () => r(require("../page/index")), "index")
          // },
          {
            // 认可激励积分 - 我的积分
            path: "/my/mine_approve",
            meta: {
              requireAuth: true
            },
            component: r =>
              require.ensure(
                [],
                () => r(require("../page/approve_mine")),
                "approve_mine"
              )
          },
          {
            // 认可激励-感谢墙
            path: "/my/thankWall",
            meta: {
              requireAuth: true
            },
            component: r =>
              require.ensure(
                [],
                () => r(require("../page/thankWall")),
                "thankWall"
              )
          },
          {
            // 感谢认可 - 互赠记录
            path: "/my/approve_record",
            meta: {
              requireAuth: true
            },
            component: r =>
              require.ensure(
                [],
                () => r(require("../page/approve_record")),
                "approve_record"
              )
          }

        ]
      },
      {
        path: "/index",
        component: r =>
          require.ensure([], () => r(require("../page/index")), "index")
      },
      {
        //感谢卡——项目
        path: "/approveProject",
        name:'approveProject',
        component: r =>
          require.ensure(
            [],
            () => r(require("../page/approve_project")),
            "previewProduct"
          ),
          meta:{
            keepAlive:true,
          }
      },
      {
        //感谢卡首页
        path: "/approve",
        name:'approve',
        component: r =>
          require.ensure(
            [],
            () => r(require("../page/approve")),
            "previewProduct"
          ),
          meta:{
            keepAlive:true,
          }
      },
      {
        //感谢卡详情
        path: "/approve_details",
        component: r =>
          require.ensure(
            [],
            () => r(require("../page/approve_details")),
            "previewProduct"
          ),
          meta:{
            keepAlive:true,
          }
      },
      {
        //感谢卡列表
        path: "/approveCardList",
        component: r =>
          require.ensure(
            [],
            () => r(require("../page/approve_card_list")),
            "previewProduct"
          ),
          meta:{
            keepAlive:true,
          }
      },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/index.js